import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flex: '1',
    height: 'calc(100svh - 80px)',
    backgroundColor: '#F0F0F0',
    overflow: 'hidden auto',
    overscrollBehaviorY: 'none',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      //@ts-ignore
      backgroundColor: theme.palette.nearWhite
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  back: {
    position: 'absolute',
    top: '16px',
    left: '16px',
    padding: '8px',
    cursor: 'pointer',
    transform: 'rotate(180deg)'
  }
}))

export default useStyles
